module.exports = __webpack_public_path__ + "static/media/store_wording.188d2eca.png";